import React, { useState,useEffect } from 'react'
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setDataLayout,
} from "../../data/redux/themeSettingSlice";
import ImageWithBasePath from "../imageWithBasePath";
import {
  setMobileSidebar,
  toggleMiniSidebar,
} from "../../data/redux/sidebarSlice";
import { all_routes } from "../../../feature-module/router/all_routes";
import { useHeaderFilters } from '../../../context/HeaderFilterContext';
import HeaderUser from './HeaderUser';
import Notifications from '../../../feature-module/notifications/Notifications';
import { useNotificationContext } from '../../../context/NotificationContext';


export interface Notification {
  id: number;
  message: string;
  createdAt: string;
  isRead: boolean;
  leaveId: number;
  userId: number;
}

const Header = () => {
  const userData = JSON.parse(localStorage.getItem("user") || "{}");
  const userId = userData?.id;
  const userrole = userData?.role_name;
  const routes = all_routes;
  const dispatch = useDispatch();
  const dataLayout = useSelector((state: any) => state.themeSetting.dataLayout);
  const { notifications,fetchUnreadNotifications } = useNotificationContext();
      const unreadCount = notifications.filter(n => !n.isRead).length;
  
    useEffect(() => {
      if (unreadCount > 0) {
        document.title = `HRMS | Log Binary (${unreadCount})`;
      } else {
        document.title = `HRMS | Log Binary`;
      }
    }, [unreadCount]);
    
  const mobileSidebar = useSelector(
    (state: any) => state.sidebarSlice.mobileSidebar
  );

  const toggleMobileSidebar = () => {
    dispatch(setMobileSidebar(!mobileSidebar));
  };

  // const miniSidebar = useSelector((state: any) => state.sidebarSlice.miniSidebar);

  // useEffect(() => {
  //   const handleSidebarWidth = () => {
  //     const root = document.documentElement;
  
  //     if (window.innerWidth < 992) {
  //       root.style.setProperty("--sidebar-width", "0px");
  //     } else {
  //       root.style.setProperty("--sidebar-width", miniSidebar ? "80px" : "250px");
  //     }
  //   };
  
  //   handleSidebarWidth(); // call on mount
  //   window.addEventListener("resize", handleSidebarWidth);
  //   return () => window.removeEventListener("resize", handleSidebarWidth);
  // }, [miniSidebar]);
  


  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 992);

	useEffect(() => {
	const handleResize = () => setIsMobileView(window.innerWidth < 992);
	window.addEventListener("resize", handleResize);
	return () => window.removeEventListener("resize", handleResize);
	}, []);

  return (
    <>
      {/* Header */}
    <div className="header">
			<div className="main-header">
        
				<div className="header-left">
				<div className="header-icons d-flex align-items-center gap-2">
          {JSON.parse(localStorage.getItem("user") || "{}")?.role_name === 1 && (
            <Link
            to="/employees"
            className="btn btn-menubar position-relative"
            >
              <i className="ti ti-users header-white header-icons-size"></i>
              </Link>
          )}

					<Link
					to="/leave/leave-request"
					className="btn btn-menubar position-relative"
					>
					<i className="ti ti-beach header-white header-icons-size"></i>
					</Link>

					<Link
					to="/payroll"
					className="btn btn-menubar position-relative"
					>
					<i className="ti ti-cash header-white header-icons-size"></i>
					</Link>

					<Link
					to="/attendance-view"
					className="btn btn-menubar position-relative"
					>
					<i className="ti ti-calendar-user header-white header-icons-size"></i>
					</Link>

          <Link
					to="/resumes"
					className="btn btn-menubar position-relative"
					>
					<i className="ti ti-id-badge-2 header-white header-icons-size"></i>
					</Link>

          {/* <Link
					to="/job-openings"
					className="btn btn-menubar position-relative"
					>
					<i className="ti briefcase header-white header-icons-size"></i>
					</Link> */}
				  </div>
				</div>

				<Link to={routes.dashboard} className="logo header-logo-hide">
						<ImageWithBasePath src="assets/img/logo3.png" alt="Logo" className='header-logo'/>
				</Link>

				<Link id="mobile_btn" onClick={toggleMobileSidebar} className="mobile_btn header-toggle" to="#sidebar">
					<span className="bar-icon">
						<span></span>
						<span></span>
						<span></span>
					</span>
				</Link>

				
				{!isMobileView && <HeaderUser />}

				
<div className="dropdown mobile-user-menu">
  <div className="d-flex align-items-center gap-2">

    {/* Notification Dropdown */}
    <div className="dropdown notification_item">
      <Link
                            to="#"
                            className="btn btn-menubar position-relative"
                            id="notification_popup"
                            data-bs-toggle="dropdown"
                            onClick={fetchUnreadNotifications}
                          >
                            <i className="ti ti-bell header-white header-icons-size"></i>
                            {unreadCount > 0 && <span className="notification-status-dot"></span>}
                          </Link>
                    {userId && (
                    <Notifications />
                    )}
      {/* <div className="dropdown-menu dropdown-menu-end notification-dropdown p-4">
        <div className="d-flex align-items-center justify-content-between border-bottom p-0 pb-3 mb-3">
          <h4 className="notification-title">Notifications (2)</h4>
          <div className="d-flex align-items-center">
            <Link to="#" className="text-primary fs-15 me-3 lh-1">Mark all as read</Link>
            <div className="dropdown">
              <Link to="#" className="bg-white dropdown-toggle" data-bs-toggle="dropdown">
                <i className="ti ti-calendar-due me-1"></i>Today
              </Link>
              <ul className="dropdown-menu mt-2 p-3">
                <li><Link to="#" className="dropdown-item rounded-1">This Week</Link></li>
                <li><Link to="#" className="dropdown-item rounded-1">Last Week</Link></li>
                <li><Link to="#" className="dropdown-item rounded-1">Last Month</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="noti-content">
          <div className="d-flex flex-column">
            <div className="border-bottom mb-3 pb-3">
              <Link to={routes.activity}>
                <div className="d-flex">
                  <span className="avatar avatar-lg me-2 flex-shrink-0">
                    <ImageWithBasePath src="assets/img/profiles/avatar-27.jpg" alt="Profile" />
                  </span>
                  <div className="flex-grow-1">
                    <p className="mb-1">
                      <span className="text-dark fw-semibold">Shawn</span> performance in Math is below the threshold.
                    </p>
                    <span>Just Now</span>
                  </div>
                </div>
              </Link>
            </div>

            <div className="border-bottom mb-3 pb-3">
              <Link to={routes.activity} className="pb-0">
                <div className="d-flex">
                  <span className="avatar avatar-lg me-2 flex-shrink-0">
                    <ImageWithBasePath src="assets/img/profiles/avatar-23.jpg" alt="Profile" />
                  </span>
                  <div className="flex-grow-1">
                    <p className="mb-1">
                      <span className="text-dark fw-semibold">Sylvia</span> added appointment on 02:00 PM
                    </p>
                    <span>10 mins ago</span>
                    <div className="d-flex justify-content-start align-items-center mt-1">
                      <span className="btn btn-light btn-sm me-2">Deny</span>
                      <span className="btn btn-primary btn-sm">Approve</span>
                    </div>
                  </div>
                </div>
              </Link>
            </div>

            <div className="border-bottom mb-3 pb-3">
              <Link to={routes.activity}>
                <div className="d-flex">
                  <span className="avatar avatar-lg me-2 flex-shrink-0">
                    <ImageWithBasePath src="assets/img/profiles/avatar-25.jpg" alt="Profile" />
                  </span>
                  <div className="flex-grow-1">
                    <p className="mb-1">
                      New student record <span className="text-dark fw-semibold">George</span> is created by
                      <span className="text-dark fw-semibold"> Teressa</span>
                    </p>
                    <span>2 hrs ago</span>
                  </div>
                </div>
              </Link>
            </div>

            <div className="border-0 mb-3 pb-0">
              <Link to={routes.activity}>
                <div className="d-flex">
                  <span className="avatar avatar-lg me-2 flex-shrink-0">
                    <ImageWithBasePath src="assets/img/profiles/avatar-01.jpg" alt="Profile" />
                  </span>
                  <div className="flex-grow-1">
                    <p className="mb-1">A new teacher record for <span className="text-dark fw-semibold">Elisa</span></p>
                    <span>09:45 AM</span>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>

        <div className="d-flex p-0">
          <Link to="#" className="btn btn-light w-100 me-2">Cancel</Link>
          <Link to={routes.activity} className="btn btn-primary w-100">View All</Link>
        </div>
      </div> */}
    </div>

    {/* Profile Dropdown */}
    <div className="dropdown profile-dropdown">
								<Link to="#" className="dropdown-toggle d-flex align-items-center" data-bs-toggle="dropdown">
									<span className="avatar avatar-sm online">
										<ImageWithBasePath src="assets/img/profiles/avatar-12.jpg" alt="Img" className="img-fluid rounded-circle"/>
									</span>
								</Link>
								<div className="dropdown-menu shadow-none">
									<div className="">
										<div className="">
											                                  <Link
                                                          className="dropdown-item"
                                                          to={`/profile/${userId}`}
                                                          // style={
                                                          //     userrole === 2
                                                          //     ? { cursor: "not-allowed", color: "gray", pointerEvents: "none" }
                                                          //     : {}
                                                          // }
                                                          onClick={(e) => {
                                                              // if (userrole !== 2) {
                                                              localStorage.setItem("pageTitle", "Profile");
                                                              // } else {
                                                              // e.preventDefault();
                                                              // }
                                                          }}
                                                          >
                                                          My Profile
                                                      </Link>
											{/* <Link className="dropdown-item" to={routes.profilesettings}>Settings</Link> */}
											<Link
											className="dropdown-item"
											to={routes.login}
											onClick={() => {
												localStorage.removeItem("token");
												localStorage.removeItem("user");
												localStorage.removeItem("tokenExpirationTime");
											}}
											>
											Logout
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
						</div>
			</div>
		</div>
      {/* /Header */}

	  {isMobileView && <HeaderUser />}
    </>
  );
};

export default Header;